<template>
    <transition name="fade">
        <div v-if="visible"
             id="error-available-slots"
             class="error-modale"
             data-html2canvas-ignore="true">
            <div class="error-modale__container">
                <button class="error-modale__close"
                        @click="close"
                        aria-label="Fermer"></button>
                <h3>Oups !</h3>
                <p class="error-modale__message">{{ message }}</p>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ErrorModal',
    data () {
        return {
            visible: false,
            message: ''
        }
    },
    methods: {
        open (msg) {
            this.message = msg
            this.visible = true
        },
        close () {
            this.visible = false
        }
    }
}
</script>

<style scoped lang="less">
.fade-enter-active, .fade-leave-active { transition: opacity .3s; }
.fade-enter, .fade-leave-to { opacity: 0; }

.error-modale {
    display: block;
    position: fixed;
    z-index: 10000;
    right: 20px;
    bottom: 20px;
    width: 600px;
    max-width: 70%;

    &__message {
        font-size: 23px;
        text-align: left;
    }

    &.active {
        display: block !important;
        animation: modale_slideIn .5s forwards;
    }

    @media (max-width: 767px) {
        max-width: unset;
    }

    &__container {
        position: relative;
        padding: 20px;
        background: #1d2f4d;
        color: #fff;

        @media (max-width: 767px) {
            padding: 15px;
        }

        &:before {
            content: "";
            background: url('/assets_bc33e7a6ebd1e4bf22d1e3afd6370c520b790c18/img/chat-formulaire.png') no-repeat center;
            background-size: contain;
            position: absolute;
            top: -59px;
            right: 50px;
            z-index: 110;
            width: 80px;
            height: 100px;
            display: block;

            @media (max-width: 767px) {
                width: 65px;
                height: 80px;
                top: -47px;
            }
        }
    }

    &__close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 20px;
        height: 20px;
        cursor: pointer;
        background-color: inherit;
        border: 0;

        @media (max-width: 767px) {
            top: 15px;
            right: 15px;
        }

        &:before,
        &:after {
            content: '';
            position: absolute;
            display: block;
            top: -4px;
            right: 10px;
            width: 2px;
            height: 25px;
            background: #FFF;
            transform: rotate(45deg);
        }

        &:after {
            transform: rotate(135deg);
        }
    }

    a {
        color: #FFFFFF;
        text-decoration: underline;
    }

    h3 {
        font-size: 28px;
        margin-right: 80px;
        color: #fff;
        margin-bottom: 5px;
        text-align: left;

        @media (max-width: 767px) {
            font-size: 14px;
            margin-right: unset;
        }
    }

    p {
        font-size: 20px;

        @media (max-width: 767px) {
            font-size: 14px;
        }
    }
}

@keyframes modale_slideIn {
    from {
        transform: translateY(200%);
    }
    to {
        transform: translateY(0);
    }
}


</style>
